class ValidationErrors {
  $formValidationTitle = document.querySelector(".js-cart-validation-modal-title");

  $formValidationQty = document.querySelector(".js-cart-validation-modal-qty");

  $formValidationMade = document.querySelector(".js-cart-validation-modal-design");

  $formValidationQtyMade = document.querySelector(".js-cart-validation-modal-qty-design");

  $validationModal = document.getElementById("cart-validation-modal");

  $validationPopup = document.getElementById("cart-validation-popup");

  // eslint-disable-next-line class-methods-use-this
  #showImg($img) {
    $img.classList.remove("hidden");
    $img.setAttribute("src", $img.dataset.src);
  }

  #updateHeader(text) {
    this.$formValidationTitle.textContent = text;
  }

  #showValidationModal() {
    $(this.$validationModal).modal("show");
    const $button = this.$validationModal.querySelector("button");
    $button?.focus();
  }

  #showValidationMadeError() {
    this.#updateHeader("Please Add Your Designs First");
    this.#showImg(this.$formValidationMade);
    this.#showValidationModal();
  }

  #showValidationQtyError() {
    this.#updateHeader("Please Tell Us How Many You Want");
    this.#showImg(this.$formValidationQty);
    if (this.$validationModal) {
      this.#showValidationModal();
    } else if (this.$validationPopup) {
      this.#showValidationPopup();
    }
  }

  #showValidationMadeQtyError() {
    this.#updateHeader("Please Add Quantities and Your Designs");
    this.#showImg(this.$formValidationQtyMade);
    this.#showValidationModal();
  }

  #showValidationPopup() {
    this.$validationPopup.classList.remove("hidden");
    setTimeout(() => {
      this.$validationPopup.classList.add("hidden");
    }, 2000);
  }

  #resetModal() {
    this.$formValidationQty.classList.add("hidden");
    this.$formValidationMade.classList.add("hidden");
    this.$formValidationQtyMade.classList.add("hidden");
  }

  show({ hasMadeErrors, hasFormErrors }) {
    this.#resetModal();

    if (hasFormErrors && !hasMadeErrors) {
      this.#showValidationQtyError();
    } else if (hasFormErrors && hasMadeErrors) {
      this.#showValidationMadeQtyError();
    } else if (!hasFormErrors && hasMadeErrors) {
      this.#showValidationMadeError();
    }
  }
}

export default () => new ValidationErrors();
